<script>
export default {
    name: "IconComment"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="800" width="800" version="1.1" id="_x32_" viewBox="0 0 512 512"
         xml:space="preserve">
        <path class="st0" fill="currentColor"
              d="M92.574 294.24V124.336H43.277C19.449 124.336 0 144.213 0 168.467v206.44c0 24.254 19.449 44.133 43.277 44.133h62v45.469c0 3.041 1.824 5.777 4.559 6.932 2.736 1.154 5.957.486 8.023-1.641l49.844-50.76h106.494c23.828 0 43.279-19.879 43.279-44.133v-.061H172.262c-43.948 0-79.688-36.17-79.688-80.606z"/>
        <path class="st0" fill="currentColor"
              d="M462.717 40H172.26c-27.105 0-49.283 22.59-49.283 50.197v204.037c0 27.61 22.178 50.199 49.283 50.199h164.668l75.348 76.033c2.399 2.442 6.004 3.172 9.135 1.852 3.133-1.322 5.176-4.434 5.176-7.887v-69.998h36.131c27.106 0 49.283-22.59 49.283-50.199V90.197C512 62.59 489.822 40 462.717 40zm-93.561 240.115H195.92v-24.316h173.236v24.316zm69.902-75.986H195.92v-24.314h243.138v24.314zm0-75.986H195.92v-24.315h243.138v24.315z"/></svg>
</template>

<style scoped lang="scss">

</style>
